/* tslint:disable */
/* eslint-disable */
import globalAxios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, RequestArgs, BaseAPI, RequiredError } from '../base';

/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Filter customers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customersGetFiltered: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/customers/filter`;
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      const baseOptions = configuration?.baseOptions;

      // Construimos los headers combinando baseOptions y options
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
        headers: {
          ...(baseOptions?.headers || {}),
          ...(options.headers || {}),
        },
      };

      // Pasar parámetros (querystring)
      const query = new URLSearchParams();
      if (options.params) {
        Object.entries(options.params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
          }
        });
      }

      localVarUrlObj.search = query.toString();
      localVarRequestOptions.params = undefined;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function (configuration?: Configuration) {
  return {
    async customersGetFiltered(
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
      const localVarAxiosArgs = await CustomersApiAxiosParamCreator(
        configuration
      ).customersGetFiltered(options);

      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
          params: undefined, // asegúrate de que axios no agregue params duplicados
        };
        return axios.request(axiosRequestArgs).catch((error) => {
          configuration?.catchError?.(error);
        });
      };
    },
  };
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    async customersGetFiltered(options?: AxiosRequestConfig): Promise<any> {
      return CustomersApiFp(configuration)
        .customersGetFiltered(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
  /**
   * Filter customers
   */
  public async customersGetFiltered(
    options?: AxiosRequestConfig
  ): Promise<any> {
    return CustomersApiFp(this.configuration)
      .customersGetFiltered(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
